// src/services/fileService.ts
import apiClient from "./apiClient";
import axios from "axios";
import { FileItem } from "../types/FileItem";

interface PresignedUploadResponse {
  uploadUrl: string;
}

interface PresignedDownloadResponse {
  downloadUrl: string;
}

export const fileService = {
  async list(prefix: string = ""): Promise<FileItem[]> {
    const response = await apiClient.get<FileItem[]>(`/Files/List`, {
      params: { prefix },
    });
    return response.data;
  },

  async renameItem(item: FileItem, newName: string): Promise<boolean> {
    const response = await apiClient.post(`/Files/rename`, {
      key: item.path,
      newName,
    });
    return response.status === 200;
  },

  async delete(key: string): Promise<boolean> {
    const response = await apiClient.delete(`/Files/Delete`, {
      params: { key },
    });
    return response.status === 200;
  },

  async download(filePath: string, fileName: string): Promise<void> {
    const response = await apiClient.get<PresignedDownloadResponse>(
      `/Files/presigned-download`,
      { params: { filePath } }
    );

    const { downloadUrl } = response.data;
    if (!downloadUrl) throw new Error("Invalid response");

    window.open(downloadUrl, "_blank", "noopener,noreferrer");
  },

    async uploadPresigned(
    file: File,
    folderPath: string = "",
    onProgress?: (percent: number) => void
  ): Promise<void> {
    // 1️⃣ Get presigned URL from backend
    const presigned = await apiClient.post<PresignedUploadResponse>(
      `/Files/presigned-upload`,
      { filePath: folderPath, contentType: file.type }
    );

    const uploadUrl = presigned.data.uploadUrl;
    if (!uploadUrl) throw new Error("Invalid upload URL");


    await axios.put(
      uploadUrl,
      file,
      {
        headers: { "Content-Type": file.type },
        onUploadProgress: (event: ProgressEvent) => {
          const { loaded, total } = event;
          const percentage = Math.floor((loaded * 100) / (total || 1));
          console.log(`Upload progress: ${percentage}%`);
           if (onProgress) onProgress(percentage);
        },
      } as any // ✅ Cast entire config as `any` to avoid TS errors
    );
  },
   
  async downloadFolderAsZip(folderPath: string, folderName: string): Promise<void> {
  const response = await apiClient.get<Blob>(`/Files/download-zip`, {
    params: { folderPath },
    responseType: "blob",
  });

  const blob: Blob = response.data; // Explicitly typed
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `${folderName}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(url);
}
};
